export const OPT_AEXT = 'OPT_AEXT'; // Option Aménagement Extérieur
export const RCS = 'RCS'; // Option Assurance Scolaire
export const BDG = 'BDG'; // Option Bris de glace
export const DOMX = 'DOMX'; // Option Dommages Electriques
export const VAN = 'VAN'; // Option Valeur à neuf
export const VLX = 'VLX'; // Option Vol et vandalisme

// Long label options
export const RCS_LABEL = 'Assurance scolaire';
export const OPT_AEXT_LABEL = 'Aménagements extérieurs (hors piscine et spa jacuzzi)';
export const VLX_LABEL = 'Vol et vandalisme';
export const BDG_LABEL = 'Bris de glace';
export const DOMX_LABEL = 'Dommages électriques';
export const VAN_LABEL = 'Valeur à neuf';
